<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.order_no" placeholder="订单号" style="width: 200px;" class="filter-item" clearable
                size="small"/>
      <el-input v-model="listQuery.user_id" placeholder="用户ID" style="width: 200px;" class="filter-item" clearable
                size="small"/>
      <el-input v-model="listQuery.nickname" placeholder="用户昵称" style="width: 200px;" class="filter-item" clearable
                size="small"/>
      <el-select v-model="listQuery.rebate_type" placeholder="返利类型" clearable style="width: 120px" class="filter-item"
                 size="small">
        <el-option label="自购" value="self_purchase_rebate"/>
        <el-option label="一代" value="generation_rebate"/>
        <el-option label="二代" value="second_generation_rebate"/>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter" size="small">搜索
      </el-button>
      <el-button class="filter-item" @click="resetFilter" size="small">重置</el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row>
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <img v-if="scope.row.user && scope.row.user.avatar" :src="scope.row.user.avatar" class="user-avatar">
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : '-' }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="返利类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.rebate_type == 'self_purchase_rebate'" type="warning">自购</el-tag>
          <el-tag v-else-if="scope.row.rebate_type == 'generation_rebate'" type="warning">一代</el-tag>
          <el-tag v-else type="warning">二代</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="返利比率" min-width="110" align="center">
        <template slot-scope="scope">
          {{ percent(scope.row.rebate_rate) }}
        </template>
      </el-table-column>
      <el-table-column label="订单金额" min-width="110" align="center">
        <template slot-scope="scope">
          ¥{{ money(scope.row.total_money) }}
        </template>
      </el-table-column>
      <el-table-column label="返利金额" min-width="110" align="center">
        <template slot-scope="scope">
          <strong>¥{{ money(scope.row.rebate_money) }}</strong>
        </template>
      </el-table-column>
      <el-table-column label="到账时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.arrival_at }}
        </template>
      </el-table-column>

      <el-table-column align="center" prop="created_at" label="创建时间" min-width="200">
        <template slot-scope="scope">
          <i class="el-icon-time"/>
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button v-if="scope.row.is_normal == 1" type="warning" size="mini"-->
<!--                     @click="handleForbid(scope.row.id, '禁用')">禁用-->
<!--          </el-button>-->
<!--          <el-button v-else size="mini" type="primary" @click="handleForbid(scope.row.id, '解禁')">解禁</el-button>-->
<!--          <el-button v-if="scope.row.is_partner == 1" type="warning" size="mini" @click="store(scope.row.id, 0)">-->
<!--            取消合伙人-->
<!--          </el-button>-->
<!--          <el-button v-else size="mini" type="primary" @click="store(scope.row.id, 1)">设为合伙人</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>

import request from '@/utils/request'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        order_no: '',
        user_id: '',
        nickname: '',
        rebate_type: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    money(value) { const number = Number(value); return Number.isFinite(number) ? number.toFixed(2) : '0.00' },
    percent(value) { const number = Number(value); return Number.isFinite(number) ? (number * 100).toFixed(2) + '%' : '-' },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/order/orderRebateLogs',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data
        this.total = response.data.total
      }).finally(() => { this.listLoading = false })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetFilter() {
      const limit = this.listQuery.limit
      this.listQuery = {page: 1, limit, order_no: '', user_id: '', nickname: '', rebate_type: ''}
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleForbid(val, text) {
      this.$confirm('此操作将' + text + '该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/backend/user/forbid',
          method: 'post',
          data: {id: val, operate: (text == '解禁' ? 1 : 0)}
        }).then(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    store(val, is_partner) {
      this.$confirm('此操作将修改该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/backend/user/store',
          method: 'post',
          data: {id: val, is_partner: is_partner}
        }).then(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
